//This functions loops through an array of ads and tallies the total amount
export const calculateLocalAdsSpend = ({ ads = [] }) => {
  const total = ads.reduce((acc, ad) => {
    if (ad.actual_total_amount_cents >= 0) {
      return acc + ad.actual_total_amount_cents
    }
    return acc
  }, 0)
  return total
}

// This separates an array of ads into groups of ad runs.  The totals and dates are then determined and returned into an easy to use object
export const groupAdDataByAdRun = ({ ads = [] }) => {
  const groups = ads.reduce((acc, ad) => {
    acc[ad.ad_run_id] = acc[ad.ad_run_id] || []
    acc[ad.ad_run_id].push(ad)
    return acc
  }, {})
  return Object.keys(groups).map((adRunId) => {
    const adRun = groups[adRunId]
    const earliestStartDate = adRun.sort((a, b) =>
      a.start_date.localeCompare(b.start_date),
    )[0].start_date
    const latestEndDate = adRun.sort((a, b) =>
      b.end_date.localeCompare(a.end_date),
    )[0].end_date
    const total = calculateLocalAdsSpend({ ads: adRun })
    return { startDate: earliestStartDate, endDate: latestEndDate, total }
  })
}

//This function filters an array of local ads by a shareId. The totals for each share are then calculated and adRun objects are created
export const filterLocalAdsForShare = ({ share, localAds = [] }) => {
  const shareId = share.id
  const ads = localAds.filter(
    (localAd) => localAd.channel_object.facebook_share.id === shareId,
  )
  const total = calculateLocalAdsSpend({ ads })
  return {
    total,
    adRuns: groupAdDataByAdRun({ ads }),
  }
}
